import styled from 'styled-components'

export const StyledModalContent = styled.div`
  padding: 30px;
  .content {
    background: #fff;
    border-radius: 16px;
    width: 435px;
    max-width: 100%;
    margin: 0 auto;
    padding: 45px;
    position: relative;

    .info {
      display: flex;
      justify-content: space-between;
      font-size: 17px;
      line-height: 24px;
      color: #8982be;
      margin-bottom: 15px;
    }

    &.loading {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      color: white;
      padding: 60px 0 40px 0;
      .title {
        font-size: 15px;
        line-height: 24px;
        color: #fafbfc;
        margin: 0;
        margin-top: 15px;
      }
      .subtitle {
        font-size: 13px;
        line-height: 21px;
        color: #ffffff;
        opacity: 0.5;
        margin: 0;
        margin-bottom: 40px;
      }
    }
    .modal-close {
      position: absolute;
      right: 0px;
      top: 0px;
      margin: 10px;
      width: 18px;
      cursor: pointer;
    }
    .balance {
      text-align: right;
      font-size: 11px;
      line-height: 13px;
      color: #777a8c;
      margin-bottom: 10px;
    }

    .input-wrap {
      height: 55px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      padding-right: 10px;
      background: #f4f5f6;

      .redeem-all {
        color: #5f4dbc;
        background: rgba(95, 77, 188, 0.1);
        border-radius: 8px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        padding: 8px 10px;
      }

      input {
        background: transparent;
        width: 100%;
        border: none;
        height: 100%;
        outline: none;
        color: #191c1e;
        font-size: 17px;
        line-height: 21px;
        padding: 0 8px;
        padding-left: 22px;
      }
    }

    .lp-tips {
      margin-top: 20px;

      p {
        font-weight: 500;
        font-size: 17px;
        line-height: 27px;
        color: #5f55a9;
      }
    }

    .button-group {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-end;
      margin-top: 10px;
      .arrow {
        margin: 0 5px;
      }
      button {
        outline: none;
        box-sizing: border-box;
        border-radius: 8px;
        color: white;
        width: 164px;
        border-radius: 45px;
        padding: 10px 0;
        cursor: pointer;
        font-size: 16px;

        &.normal {
          background: transparent;
          border: 1px solid #5f4dbc;
          color: #5f4dbc;
        }

        &.primary {
          background: #5f4dbc;
          border: 0.5px solid rgba(255, 255, 255, 0.05);
        }

        &.disabled {
          opacity: 0.1;
        }
      }
    }
  }

  @media screen and (max-width: 660px) {
    flex: 1;
    padding: 0;
    .content {
      height: 100%;
      width: 100%;
      padding-top: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: 10px;
      padding-right: 10px;

      .input-wrap {
        background: white;
        input {
          color: #666;
        }
      }

      .modal-close {
        margin: 10px;
      }
      .button-group {
        margin-top: 25px;
      }
      button.primary {
        width: 100%;
      }
      .lp-tips {
        padding: 0 15px;
        font-size: 13px;

        p {
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
  }
`
